import { render, staticRenderFns } from "./identifyDialog2.vue?vue&type=template&id=738dacbc&scoped=true&"
import script from "./identifyDialog2.vue?vue&type=script&lang=ts&"
export * from "./identifyDialog2.vue?vue&type=script&lang=ts&"
import style0 from "./identifyDialog2.vue?vue&type=style&index=0&id=738dacbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738dacbc",
  null
  
)

export default component.exports